import { useDispatch, useSelector } from "react-redux";
import { ON_FORM_CHANGE, SET_ERROR } from "../../redux/constants";
import { setErrors } from "../../shared/CustomFunc";
import { ApiContainer } from "../../utils/api";

const CreateEditContainer = ({ formPath, loaderState }) => {
  const dispatch = useDispatch();
  const { api } = ApiContainer();

  const formData = useSelector(
    (state) => state.form.formData?.[formPath.parent]
  );
  const loader = useSelector((state) => state.api?.loader?.[loaderState]);

  const form = useSelector((state) => state?.form);

  const formDataError = useSelector(
    (state) => state.form.formErrors?.[formPath.parent]
  );

  const eventScheduleToEdit = useSelector(
    (state) => state.api?.eventScheduleToEdit
  );

  const setFormData = (name, value) => {
    dispatch(setErrors({ errors: formDataError, value, name, formPath }));
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...form.formData,
          [formPath.parent]: { ...formData, [name]: value },
        },
      },
    });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files?.length > 0) {
      const file = files[0];
      const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");
      if (!isCSV) {
        dispatch({
          type: SET_ERROR,
          payload: {
            formErrors: {
              ...form.formErrors,
              [formPath.parent]: {
                ...formDataError,
                [name]: "Only CSV files are allowed",
              },
            },
          },
        });
        setFormData(name, null);
        return;
      }
      dispatch({
        type: SET_ERROR,
        payload: {
          formErrors: {
            ...form.formErrors,
            [formPath.parent]: {
              ...formDataError,
              [name]: "",
            },
          },
        },
      });

      setFormData(name, file);
    } else {
      setFormData(name, value);
    }
  };

  const handleMobileChange = (mobile, name) => {
    setFormData(name, `+${mobile}`);
  };
  const handleDateChange = (value, name) => {
    setFormData(name, new Date(value).toLocaleDateString("en-US"));
  };

  const handleTimeChange = (newValue, name) => {
    if (!newValue) return;
    setFormData(name, newValue);
  };
  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData(name, checked);
  };
  const handleChangePhoto = (e) => {
    const { name, files } = e.target;
    setFormData(
      name,
      files && files?.[0]
        ? {
            photo_url: URL.createObjectURL(files[0]),
            photo_file: files[0],
          }
        : null
    );
  };

  const downloadTemplateFile = async () => {
    const fileUrl =
      "https://vasana-static.s3.us-east-1.amazonaws.com/set-event-schedule.csv";
    const fileName = "Create Event Schedule.csv";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    link.click();
  };

  const DownloadUploadedCSVFile = async () => {
    const data = await api({
      method: "GET",
      endPoint: `download/member-schedule-list?event_schedule_id=${eventScheduleToEdit?.id}`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "downloadCSVFile",
      needFullResponse: false,
    });

    if (data?.status && data?.data) {
      const csvContent = data?.data;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      const fileName = `Event_Schedule_${eventScheduleToEdit?.event_id}.csv`;
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const removeUploadedFile = () => {
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...form.formData,
          [formPath.parent]: {
            ...formData,
            csv_file: null,
            csv_file_data: null,
          },
        },
        formErrors: {
          ...form.formErrors,
          [formPath.parent]: {
            ["csv_file"]: "",
          },
        },
      },
    });
  };

  return {
    handleChange,
    handleMobileChange,
    formData,
    loader,
    handleDateChange,
    handleTimeChange,
    handleChangePhoto,
    handleSwitchChange,
    downloadTemplateFile,
    DownloadUploadedCSVFile,
    removeUploadedFile,
  };
};

export default CreateEditContainer;
